// Departamentos do City View — grid 3x2, conforme docs/07-dashboard/DASHBOARD_UI_SPECS.md.
// Background de cada um em assets/sprites/background-<id>.png (servido em /sprites/).
export const DEPARTMENTS = [
  { id: "recepcao", label: "Recepção", background: "/sprites/background-recepcao.png" },
  { id: "vitrine", label: "Vitrine", background: "/sprites/background-vitrine.png" },
  { id: "sala-consulta", label: "Sala de Consulta", background: "/sprites/background-sala-consulta.png" },
  { id: "caixa", label: "Caixa", background: "/sprites/background-caixa.png" },
  { id: "atelie", label: "Ateliê", background: "/sprites/background-atelie.png" },
  { id: "correios", label: "Correios", background: "/sprites/background-correios.png" },
];
